import { LocalStorageKeys } from "@/enums";
import { computed } from "vue";

export function useMealsPermissions() {
  const view = computed(() => {
    return !!localStorage.getItem(LocalStorageKeys.NewMealActivation);
  });

  return { view };
}
